const whole = (value) => typeof value === 'number' && Number.isFinite(value) && value > 0 ? Math.floor(value) : 0;
/** The named people marked coming, by adult and child. */
export function namedComing(members) {
    return members.reduce((count, member) => {
        if (member.attending !== true)
            return count;
        if (member.memberType === 'CHILD')
            count.kids += 1;
        else
            count.adults += 1;
        return count;
    }, { adults: 0, kids: 0 });
}
/** The named people marked not coming. */
export function namedNotComing(members) {
    return members.filter((member) => member.attending === false).length;
}
/**
 * How many of a party's head count are nobody named — what is left once the
 * named people coming are taken off. Never below zero.
 */
export function othersComing(members, adultCount, kidCount) {
    const named = namedComing(members);
    return {
        adults: Math.max(0, whole(adultCount) - named.adults),
        kids: Math.max(0, whole(kidCount) - named.kids),
    };
}
/** The party's head count: the named people coming plus the unnamed others. */
export function headCountWith(members, others) {
    const named = namedComing(members);
    return { adults: named.adults + whole(others.adults), kids: named.kids + whole(others.kids) };
}
/**
 * A head count raised, where it must be, to cover the named people coming —
 * a count below them contradicts the names and is the names' to win.
 */
export function atLeastNamed(members, adultCount, kidCount) {
    const named = namedComing(members);
    return {
        adults: Math.max(whole(adultCount), named.adults),
        kids: Math.max(whole(kidCount), named.kids),
    };
}
//# sourceMappingURL=partyAttendance.js.map